const topbar = require('topbar');

export const show = () => topbar.show();
export const hide = () => topbar.hide();